import "./modal.css";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import i18n from "../Components/i18n";
import TimeModal from "./Timemodel2";
import { client } from "./Socket";
import * as countryCodes from "country-codes-list";
import { female, male } from "./MaleJson";
import loda from "lodash";
import TimeBox from "./Timebox2";
import SideBar from "../Components/SideBar";
import { useTranslation } from "react-i18next";
import scheduleJson from "./data";
const myCountryCodesObject = countryCodes.customList(
  "countryNameEn",
  "+{countryCallingCode}"
);

function Schedule({ children, toggleLanguage }) {
  // ✅ Use the hook here inside the component
  const { t } = useTranslation();
  const location = useLocation();
  useEffect(() => {
    if (!location.state) {
      console.log("abc@@@");
      if (localStorage.getItem("loggedin")) {
        navigate("/management");
        return;
      } else {
        navigate("/");
        return;
      }
    } else {
      console.log("abc");
    }
    // eslint-disable-next-line
  }, []);
  // console.log(location.state);
  const [countryArr, setCountryArr] = useState([
    {
      name: "dsg",
    },
  ]);
  const [alertPhoneNumber, setAlertPhoneNumber] = useState([]);
  const [genderState, setGenderState] = useState(null);
  const [timeBoxPopUp, setTimeBoxPopUp] = useState(false);
  const [timeArr, setTimeArr] = useState([]);
  const [defaultState, setDefaultState] = useState(false);
  const [timeEditData, setTimeEditData] = useState({});

  const getData = async () => {
    const config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `https://db2sg.com/HamitaherApi/schedules.php?user_id=${location.state.user.id}&esp_id=${location.state?.esp_id}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        const resData = response.data;

        setGenderState(resData.data.gender);

        const alertPhoneNumber = (
          (resData.data?.phone && resData.data.phone) ||
          []
        ).map((el, index) => {
          return {
            phone: el,
            country: resData.data?.country
              ? (resData.data?.country)[index]
              : "",
          };
        });
        setAlertPhoneNumber(alertPhoneNumber);

        setDefaultState(resData.data?.default === "1");
        if (resData.data?.default === "1" && resData.data.gender === 1) {
          if (
            scheduleJson.status === "success" &&
            Array.isArray(scheduleJson.schedules)
          ) {
            const filtered = scheduleJson.schedules.filter(
              (sch) => !sch.name?.toLowerCase().includes("female")
            );
            console.log("Filtered schedules:", filtered);
            setSchedules(filtered);
          }
        } else {
          if (
            scheduleJson.status === "success" &&
            Array.isArray(scheduleJson.schedules)
          ) {
            const filtered = scheduleJson.schedules.filter((sch) =>
              sch.name?.toLowerCase().includes("female")
            );
            console.log("Filtered schedules:", filtered);
            setSchedules(filtered);
          }
        }
        // Parse Repetitions
        let tempArr = [];
        let tempdata = {};
        try {
          if (resData.data?.repetations) {
            tempdata = JSON.parse(resData.data.repetations);
          }
        } catch (error) {
          console.error("Error parsing repetations data:", error);
        }

        if (Object.keys(tempdata).length > 0) {
          for (let key in tempdata) {
            let obj = { time: key, ...tempdata[key] };
            tempArr.push(obj);
          }
        }

        setTimeArr(tempArr);
        if (resData.data?.default === "1") {
          let filtered = [];
        
          if (scheduleJson.status === "success" && Array.isArray(scheduleJson.schedules)) {
            filtered = scheduleJson.schedules.filter((sch) =>
              resData.data.gender === "1"
                ? !sch.name?.toLowerCase().includes("female")
                : sch.name?.toLowerCase().includes("female")
            );
            setSchedules(filtered);
          }
        
          const matched = filtered.find((sch) => {
            const tempdata = sch.schedule;
            const tempArr2 = [];
            for (let key in tempdata) {
              tempArr2.push({ time: key, ...tempdata[key] });
            }
            return loda.isEqual(tempArr2, tempArr);
          });
        
          if (matched) {
            setSelectedSchedule(matched.id);
          } else {
            setSelectedSchedule("");
          }
        }
        // Prepare and publish data
        const repetations = {};
        tempArr.forEach((el) => {
          repetations[el.time] = { days: el.days, status: el.status };
        });
      })
      .catch((error) => {
        console.error("API error:", error);
      });
  };
  useEffect(() => {
    const subArr = ["phone", "gender", "default", "repetations"];
    const topics = subArr.map((el) => `${location.state?.esp_id}/${el}`);
    client.subscribe(topics, (err) => {
      if (err) console.log(err);
    });

    // Initial Country Array Setup
    setCountryArr([]);
    for (let key in myCountryCodesObject) {
      setCountryArr((prev) =>
        prev.concat({ name: `${key} ${myCountryCodesObject[key]}` })
      );
    }
    getData();
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    function handleMessage(topic, message) {
      // Handle topics
      if (topic.split("/")[1] === "repetations") {
        let tempArr = [];
        let tempdata = JSON.parse(message.toString());
        // console.log(tempdata);
        for (let key in tempdata) {
          let obj = { time: key, ...tempdata[key] };
          tempArr.push(obj);
        }

        setTimeArr(tempArr);
        
      }
      if (topic.split("/")[1] === "gender") {
        setGenderState(JSON.parse(message.toString()));
      }
      if (topic.split("/")[1] === "default") {
        setDefaultState(JSON.parse(message.toString()));
      } else {
       
      }
      console.log(topic);
      console.log(message.toString());
    }

    client.on("message", handleMessage);

    // Cleanup on unmount
    return () => {
      client.off("message", handleMessage);
      // Also clear all timers
    };
  }, []);
  /////////////////////////////////////

  const addNewNumber = async () => {
    if (alertPhoneNumber.length > 2) {
      return;
    }
    setAlertPhoneNumber((prev) => [...prev, { phone: "", country: "" }]);
  };

  const deleteNumber = (el) => {
    setAlertPhoneNumber((prev) => prev.filter((ele) => ele !== el));
  };

  const saveFormData = () => {
    if (alertPhoneNumber.length > 3) {
      alert("You can't add more than 3 phone numbers");
      return;
    }

    for (let i = 0; i < alertPhoneNumber.length; i++) {
      if (
        alertPhoneNumber[i].phone.length < 10 ||
        alertPhoneNumber[i].phone.length > 15
      ) {
        alert("Phone number is not valid");
        return;
      }
    }

    let repetations = {};
// eslint-disable-next-line
    timeArr.map((el) => {
      repetations[el.time] = { days: el.days, status: el.status };
    });
    client.publish(
      location.state?.esp_id + "/repetations",
      `${JSON.stringify(repetations)}`
    );
    client.publish(location.state?.esp_id + "/gender", `${genderState}`);
    client.publish(
      location.state?.esp_id + "/default",
      `${JSON.stringify(defaultState ? 1 : 0)}`
    );

    client.publish(
      location.state?.esp_id + "/phone",
      `${JSON.stringify(alertPhoneNumber.map((el) => el.phone))}`
    );
    client.publish(
      location.state?.esp_id + "/country",
      `${JSON.stringify(alertPhoneNumber.map((el) => el.country))}`
    );
    console.log(timeArr, alertPhoneNumber, genderState, defaultState);

    const updated_schedule = {
      alert: {
        device: location.state?.esp_id,
        isDefault: defaultState,
        isFemale: genderState === "0" ? true : false,
        mobNumber: alertPhoneNumber.map((el) => el.phone),
        country: alertPhoneNumber.map((el) => el.country),
        timeStamp: new Date().toLocaleString(),
      },
      schedules: timeArr,
    };
    console.log(updated_schedule);
    console.log("====================================");
    console.log(location.state);
    axios.post(
      `https://db2sg.com/HamitaherApi/schedules.php?user_id=${location.state.user.id}&esp_id=${location.state.esp_id}`,
      {
        schedule: updated_schedule,
      }
    );

    console.log("====================================");
    alert("Schedule saved successfully");
  };
  console.log(alertPhoneNumber);

  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const isDisabledAll = !timeArr.some((el) => el.status);
  const [selectedSchedule, setSelectedSchedule] = useState("");
  const [schedules, setSchedules] = useState([]);

  useEffect(() => {
    if (defaultState) {
      console.log(genderState)
      let filtered = [];
      if (scheduleJson.status === "success" && Array.isArray(scheduleJson.schedules)) {
        filtered = scheduleJson.schedules.filter((sch) =>
          genderState === "1"||genderState === 1
            ? !sch.name?.toLowerCase().includes("female")
            : sch.name?.toLowerCase().includes("female")
        );
        setSchedules(filtered);
      }
  
      // Now use the updated timeArr to find match

      let matchedSchedule = null;
  
      filtered.forEach((sch, index) => {
        const tempdata = sch.schedule;
        const tempArr = [];
        for (let key in tempdata) {
          tempArr.push({ time: key, ...tempdata[key] });
        }
  
        if (loda.isEqual(tempArr, timeArr)) {
          matchedSchedule = sch;
        }
      });
  
      if (matchedSchedule) {
        setSelectedSchedule(matchedSchedule.id);
      } else {
        setSelectedSchedule("");
      }
    }
  }, [defaultState, timeArr, genderState]);
  
  return (
    <div>
      <SideBar />
      <div className="topbar" style={{ backgroundColor: "#8ec0fc" }}>
        <div className="container-fluid devices_topbar">
          <div className="row d-flex align-items-center justify-content-evenly">
            <div className="col text-center px-3 d-flex flex-start">
              <span
                className="mb-0"
                style={{
                  color: "#000",
                  fontSize: "100%",
                  background:
                    "linear-gradient(45deg, #000, #000, #000, #000)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                {localStorage.getItem("name")?.toUpperCase()}
              </span>
            </div>
            <div
              className="col-1 d-flex justify-content-evenly align-items-center"
              style={{
                width: defaultState ? "810px" : "710px",
                justifyContent: "space-between",
                fontSize: "90%",
              }}
            >
              <img
                onClick={() => {
                  setModalOpen(true);
                }}
                src="assets/bell.png"
                width={22}
                height={22}
                style={{
                  filter:
                  "sepia(0) saturate(140) brightness(0.9) hue-rotate(200deg)",
                }}
                alt="Battery"
              />

              <button
                onClick={saveFormData}
                className="btn"
                style={{  marginLeft: "20px", }}
              >
                {t("Save")}
              </button>

              <div
                className="radio-group"
                style={{
                  background:
                    "linear-gradient(45deg, #000, #000, #000, #000)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  marginLeft: "20px",
                }}
              >
                <label style={{ fontSize: "90%" }}>
                  <input
                    type="radio"
                    name="gender"
                    value="1"
                    style={{
                      accentColor: "#8ec0fc",
                      border: "none",
                      height: "17px",
                      width: "17px",
                    }}
                    onChange={(e) => {
                      if (e.target.value && defaultState) {

                        if (
                          scheduleJson.status === "success" &&
                          Array.isArray(scheduleJson.schedules)
                        ) {
                          const filtered = scheduleJson.schedules.filter(
                            (sch) => !sch.name?.toLowerCase().includes("female")
                          );
                          console.log("Filtered schedules:", filtered);
                          setSchedules(filtered);
                        }
                      }
                      setGenderState("1");
                    }}
                    checked={genderState === "1"||genderState === 1}
                  />
                  {t("Male")}
                </label>
                <label style={{ fontSize: "90%" }}>
                  <input
                    type="radio"
                    name="gender"
                    value="0"
                    style={{
                      accentColor: "#8ec0fc",
                      border: "none",
                      height: "17px",
                      width: "17px",
                    }}
                    checked={genderState === "0"||genderState === 0}
                    onChange={(e) => {
                      setGenderState("0");
                      if (e.target.value && defaultState) {
                        if (
                          scheduleJson.status === "success" &&
                          Array.isArray(scheduleJson.schedules)
                        ) {
                          const filtered = scheduleJson.schedules.filter(
                            (sch) => sch.name?.toLowerCase().includes("female")
                          );
                          console.log("Filtered schedules:", filtered);
                          setSchedules(filtered);
                        }
                      }
                    }}
                  />
                  {t("Female")}
                </label>
              </div>

              <label style={{ marginLeft: "20px" }} className="switch">
                <input
                  type="checkbox"
                  checked={
                    timeArr.find((el) => el.status === true) ? false : true
                  }
                  onClick={(e) => {
                    let re = timeArr.find((el) => el.status === true)
                      ? false
                      : true;
                    setTimeArr(
                      timeArr.map((el) => {
                        return {
                          ...el,
                          status: re,
                        };
                      })
                    );
                    setDefaultState(false);
                  }}
                  name="loading"
                />
                <span className="slider"></span>
              </label>
              <span
                style={{
                  background:
                    "linear-gradient(45deg, #000, #000, #000, #000)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                {t("Disabel All")}
              </span>

              <label style={{ marginLeft: "20px" }} className="switch">
                <input
                  type="checkbox"
                  checked={defaultState}
   
    onChange={(e) => {
      const checked = e.target.checked;
      setDefaultState(checked);
    
      if (checked) {
        // Enable all times first
        const newTimeArr = timeArr.map((el) => ({
          ...el,
          status: true,
        }));
        setTimeArr(newTimeArr);
      } else {
        setSelectedSchedule("");
      }
    }}
    
                  name="loading"
                />
                <span className="slider"></span>
              </label>
              <span
                style={{
                  background:
                    "linear-gradient(45deg, #000, #000, #000, #000)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                {t("Default")}
              </span>
              {defaultState && schedules.length > 0 && (
                <select
                  style={{
                    marginLeft: "20px",
                    maxWidth: "90px",
                    height: "30px",
                    fontSize: "12px",
                    paddingTop: 0,
                    paddingBottom: 0,
                  }}
                  value={selectedSchedule}
                  onChange={(e) => {
                    const scheduleId = e.target.value;
                    setSelectedSchedule(scheduleId);

                    // find the selected schedule object
                    const selected = schedules.find((s) => s.id === scheduleId);

                    if (selected) {
                      // convert schedule JSON to time array
                      let tempArr = [];
                      const tempdata = selected.schedule;
                      for (let key in tempdata) {
                        let obj = { time: key, ...tempdata[key] };
                        tempArr.push(obj);
                      }
                      setTimeArr(tempArr);
                    }
                  }}
                >
                  <option value="">Select</option>
                  {schedules.map((s, index) => (
                    <option
                      style={{ textAlign: "center" }}
                      key={s.id}
                      value={s.id}
                    >
                      {index + 1}
                    </option>
                  ))}
                </select>
              )}

              <label style={{ marginLeft: "20px" }} className="switch">
                <input
                  type="checkbox"
                  checked={i18n.language === "he"}
                  onChange={toggleLanguage}
                  name="loading"
                />
                <span className="slider"></span>
              </label>
              <span
                style={{
                  background:
                    "linear-gradient(45deg, #000, #000, #000, #000)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                {i18n.language === "en" ? "Hebrew" : "Hebrew"}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="content">
        {modalOpen && (
          <div className="modal-container">
            <div className="modal">
              <div className="modal-header">
                <h2>{t("Settings")}</h2>
                <button
                  className="close-btn"
                  onClick={() => setModalOpen(false)}
                >
                  ✖
                </button>
              </div>

              <div className="modal-body">
                <div>
                  <label style={{ color: "#5D5F63", fontSize: "100%" }}>
                    {t("Alert phone number")}
                  </label>
                  {alertPhoneNumber?.map((el, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        gap: "15px",
                        alignItems: "center",
                      }}
                    >
                     {/* { el.country + " " + el.phone.split("-")[0]} */}
                      <select
                        // value={el.country + " " + el.phone.split("-")[0]} // Use 'value' instead of 'defaultValue'
                        value={
                          (() => {
                            const phoneCode = el.phone?.split("-")[0]?.trim() || "";
                            // Find matching country from countryArr by code
                            const matched = countryArr?.find((c) => c.name.includes(phoneCode));
                            return matched
                              ? matched.name
                              : el.country && phoneCode
                              ? `${el.country} ${phoneCode}`
                              : ""; // fallback to blank (Select Country)
                          })()
                        }
                        onChange={(e) => {
                          console.log(e.target.value);
                          const newValue = e.target.value;
                          if (!newValue) return;

                          setAlertPhoneNumber((prev) => {
                            const newArr = [...prev];
                            newArr[index]["country"] = newValue
                              .split("+")[0]
                              .trim();

                            if (el.phone.includes("-")[1]) {
                              newArr[index]["phone"] =
                                "+" +
                                newValue.split("+")[1].trim() +
                                "-" +
                                el.phone.split("-")[1];
                            } else {
                              newArr[index]["phone"] =
                                "+" + newValue.split("+")[1].trim();
                            }
                            return newArr;
                          });
                        }}
                        style={{
                          width: "40%",
                          padding: "8px",
                          borderRadius: "6px",
                          border: "1px solid #D9D9D9",
                          fontSize: "90%",
                        }}
                      >
                        <option value="">Select Country</option>{" "}
                        {/* Placeholder Option */}
                        {countryArr?.map((ele) => (
                          <option key={ele.name} value={ele.name}>
                            {ele.name}
                          </option>
                        ))}
                      </select>

                      <input
                        type="text"
                        value={el.phone.split("-")[1] || ""}
                        placeholder={t("Enter an alert phone number")}
                        onChange={(e) => {
                          const newNumber = e.target.value;
                          setAlertPhoneNumber((prev) => {
                            const newArr = [...prev];
                            const prefix = el.phone.split("-")[0] || "";
                            newArr[index]["phone"] = `${prefix}-${newNumber}`;
                            return newArr;
                          });
                        }}
                        style={{
                          width: "60%",
                          padding: "8px",
                          borderRadius: "6px",
                          border: "1px solid #D9D9D9",
                          fontSize: "90%",
                        }}
                      />

                      <button
                        onClick={() => {
                          if (alertPhoneNumber.length === 1) {
                            alert("min one phone number req*");
                          } else {
                            deleteNumber(el);
                          }
                        }}
                        className="delete-btn"
                      >
                        <img
                        alt=""
                          src="assets/delete.png"
                          style={{
                            width: "50%",
                            height: "auto",
                            filter:
                            "sepia(0) saturate(140) brightness(0.9) hue-rotate(200deg)",
                          }}
                        />
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              <div className="modal-footer">
                <button
                  onClick={() => {
                    addNewNumber();
                  }}
                  className="btn"
                >
                  {t("Add New Number")}
                </button>
                <button className="btn" onClick={() => setModalOpen(false)}>
                  {t("Cancel")}
                </button>
              </div>
            </div>
          </div>
        )}
        <div
          style={{
            padding: "10px",
            minHeight: "87vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, minmax(250px, 1fr))", // 2x2 grid
              gap: "10px",
              maxWidth: "1300px", // Limits max width for better alignment
              width: "100%",
              
            }}
          >
            <div
              onClick={() => {
                if (timeArr.length >= 30) {
                  alert("Maximum Limit Reached only 30 Schedules are allowed");
                  return;
                }
                if (defaultState) {
                  setDefaultState(false);
                }
                setTimeBoxPopUp(true);
              }}
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "0px",
                margin: "10px",
              
              }}
            >
              <div
                style={{
                  background: "rgba(255, 255, 255, 0.2)", // Light green background for freshness
                  borderRadius: "8px",
                  padding: "30px",
                  width: "380px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "12px",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                }}
              >
                <img
                alt=""
                  src="assets/add.png"
                  style={{
                    width: "80px",
                    height: "auto",
                    filter:
                    "sepia(0) saturate(140) brightness(0.9) hue-rotate(200deg)",
                  }}
                />
              </div>
            </div>
            {timeArr
              ?.sort((a, b) => {
                const timeA = a.time.split("T")[0];
                const timeB = b.time.split("T")[0];
                return timeA.localeCompare(timeB);
              })
              .map((time, index) => (
                <div key={index}>
                  <TimeBox
                    data={time}
                    setTimeBoxPopUp={setTimeBoxPopUp}
                    setTimeEditData={setTimeEditData}
                    setTimeArr={(e) => {
                      setTimeArr(e);
                      setDefaultState(false);
                    }}
                    timeArr={timeArr}
                    isDisabledAll={isDisabledAll}
                  />
                </div>
              ))}
          </div>
        </div>

        <TimeModal
          open={timeBoxPopUp}
          onClose={() => {
            setTimeEditData({});
            setTimeBoxPopUp(false);
          }}
          timeEditData={timeEditData}
          setTimeArr={(e) => {
            if (loda.isEqual(e, male) && ("genderState" === "1"||genderState === 1)) {
              setDefaultState(true);
            } else if (loda.isEqual(e, female) && (genderState === "0"||genderState === 0)) {
              setDefaultState(true);
            } else {
              setDefaultState(false);
            }
            setTimeArr(e);
          }}
          timeArr={timeArr}
        />
      </div>
    </div>
  );
}

export default Schedule;
